import React from 'react';
import { hot } from 'react-hot-loader';
import s from './Input.scss';


const Input = ({ id, type, value, readOnly, inputChange, inputBlur = () => {}, isError = false, placeholder = ' ', defaultValue = '', label = null, extraAttrs = {}, width = '100%' }) => {
	const inputChangeHandlar = (e) => {
		e.preventDefault();
		const $input = e.currentTarget;
		inputChange($input.id, $input.value);
	};

	const inputBlurHandler = (e) => {
		const $input = e.currentTarget;
		inputBlur($input.id, $input.value);
	};

	const inputClasses = [s.input];
	const labelClasses = [s.label];

	if (isError) {
		labelClasses.push(s.label__error);
		inputClasses.push(s.input__error);
	}
	if (readOnly) extraAttrs = { ...extraAttrs, tabIndex: -1 };
	const widthStyle = {
		input: { width: (label ? '100%' : width) },
		label: { width },
	};

	const input = <input className={inputClasses.join(' ')} id={id} name={id} readOnly={readOnly} type={type} value={value || defaultValue} placeholder={placeholder} onChange={inputChangeHandlar} onBlur={inputBlurHandler} {...extraAttrs} style={widthStyle.input} />;

	if (label) {
		return (
			<label className={labelClasses.join(' ')} htmlFor={id} style={widthStyle.label}>
				{ input }
				<span className={s.input_labelText}>{ label }</span>
			</label>
		);
	}
	return input;
};

export default hot(module)(Input);
